export const RAVAGO_COMPANY_NAME = "ravago";
export const LAYOUT_HEADER_BAR = 64;
export const MODAL_WIDTH_LARGE = 800;

export enum Keys {
  ESCAPE = "ESCAPE",
  ENTER = "ENTER",
  BACKSPACE = "BACKSPACE",
}
